import MyTinySlider from './MyTinySlider';
import { onDomReady } from '../../components/dynamic/observer';

onDomReady(() => {
  if (!document.querySelector('[data-about-advantages-slider-container]')) {
    return;
  }
  const aboutAdvantagesSlider = new MyTinySlider({
    sliderContainer: '[data-about-advantages-slider-container]',
    sliderList: '[data-about-advantages-slider]',
    arrowLeft: '[data-about-advantages-left]',
    arrowRight: '[data-about-advantages-right]',
    slideIndex: '[data-about-advantages-slider-index]',
    slideCount: '[data-about-advantages-count]',
    slideBy: 1,
    nav: true,
    navPosition: 'bottom',
    speed: 700,
    center: true,
    controls: false,
    rewind: true,
    loop: false,
    responsive: {
      0: {
        gutter: 12,
        fixedWidth: 338,
      },
      768: {
        gutter: 24,
        fixedWidth: 452,
      },
      1280: {
        gutter: 28,
        fixedWidth: 584,
      },
    },
  });
});